// extracted by mini-css-extract-plugin
export default {"container":"arrowBotton_container__lO7kA","button":"arrowBotton_button__pPTrt","img":"arrowBotton_img__XSdPd"};